import { h } from '@debbie/cortex/dist/index.js';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import { getBadgesToShow } from '@debbie/cortex/dist/insights/selectors.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { Badge } from '..//index.js';
import X from '../Icons/X.js';
const CaseFilterBadges = (props) => {
    const stateCaseFilter = useCaseFilter();
    const lang = useSelector((s) => s.lang);
    const caseFilter = props.caseFilter || stateCaseFilter;
    const propertyTypes = usePropertyTypes();
    const badgesToShow = getBadgesToShow(caseFilter, lang, h.hasData(propertyTypes) ? propertyTypes.data : []);
    return (React.createElement(React.Fragment, null, badgesToShow.map((badge, i) => (React.createElement(Badge, { key: i, theme: THEME.COLOR_PRIMARY, style: {
            cursor: 'pointer',
            margin: '0 5px 5px 0',
            lineHeight: '1.8em',
        }, onClick: badge.onDeactivate },
        typeof badge.label === 'function'
            ? // @ts-ignore
                badge.label(THEME.DATE_FORMAT)
            : badge.label,
        ' ',
        React.createElement(X, { style: { margin: '0.1em 0px -0.1em' } }))))));
};
export default CaseFilterBadges;
//# sourceMappingURL=CaseFilterBadges.js.map